<div class="chat-item" routerLink="/messenger/{{ conversation.uniqueName }}">
  <app-user-avatar [size]="48" [user]="mainParticipantUser"></app-user-avatar>
  <div class="chat-item_info">
    <span class="title">{{ mainParticipantUser?.userName || '...' }}</span>
    <span 
      *ngIf="getConversationUnreadCount(conversation)" 
      class="p6 grey-text"
    >{{ conversation.lastMessageBody || '...' }}</span>
    <span 
      *ngIf="!getConversationUnreadCount(conversation)" 
      class="p6 grey-text"
    >{{ conversation.lastMessageDateCreated | creationDate }}</span>
  </div> 

  <span class="p6 chat-item_counter" *ngIf="getConversationUnreadCount(conversation) as unreadCount">
    {{  unreadCount | formattedCount:99 }}
  </span>
</div>